import React, { createContext, useContext, useState } from "react";
import {customLabelsState}  from './appState';

export const CustomLabelsContext = createContext();
export const useCustomLabelsContext = () => useContext(CustomLabelsContext);

export const CustomLabelsProvider = (props) => {
    const [appState, setAppState] = useState(customLabelsState);
    

    const setCustomLabels= (customLabels = []) => {
        setAppState({
            ...appState,
            customLabels: customLabels
        })
    }


    return (
        <CustomLabelsContext.Provider value={{
            appState, setAppState ,setCustomLabels
        }} >
            {props.children}
        </CustomLabelsContext.Provider>
    );

}
